const actorNameCounts: Record<string, number> = {};

export function actorName(name: string): string {
  const count = actorNameCounts[name] ?? 0;
  actorNameCounts[name] = count + 1;
  return `${name}_${count}`;
}
